import React from 'react';

import { useOrderContext } from '@/components/modals/SubmitOrder/helpers';
import { formatPriceWithCurrency } from '@/utils/format-price';

import { OrderDetails } from '../../../Common/OrderDetails';
import { ProposalBlockWrapper } from '../../../Common/ProposalBlockWrapper';
import { accessAddonInfo } from '../../../OrderInfoStep/AddonsList/components/AddonRow/constants';

import { Props } from './types';

import styles from '../../ConfirmationStep.module.scss';

export const ConfirmationContractDetails = ({ goToStep }: Props) => {
  const state = useOrderContext();
  const isActivityDistributionModel = state.isAccessProgram && state.isDistribution;

  const projectOptions = state?.order?.projectOptions ?? {};
  const projectOptionsOrder = ['rainGutters', 'gutters', 'decking', 'skylights'];

  const renderProjectOptions = () => {
    return projectOptionsOrder.map(option => {
      const { label } = accessAddonInfo[option];
      const price = projectOptions[option]?.price ?? null;

      return (
        <div className={styles.order_list_body_item} key={option}>
          <div className={styles.order_list_body_raw}>
            <span className={styles.order_list_body_item_bold}>{label}</span>
            {!state.isPriceHidden && (
              <span className={styles.order_list_body_item_bold}>
                {price === null ? 'No' : formatPriceWithCurrency(price, 0)}
              </span>
            )}
          </div>
        </div>
      );
    });
  };

  if (!isActivityDistributionModel) {
    return null;
  }

  return (
    <ProposalBlockWrapper
      link={{
        label: 'Edit Details',
        click: goToStep,
      }}
      title="Contract Details"
    >
      <OrderDetails hideValue title="Contract Details" value={0}>
        <div className={styles.order_list_body_item}>
          <div className={styles.order_list_body_raw}>
            <span className={styles.order_list_body_item_bold}>Financing</span>
            {!state.isPriceHidden && (
              <span className={styles.order_list_body_item_bold}>
                {state.order.isFinancingIncluded ? 'Yes' : 'No'}
              </span>
            )}
          </div>
        </div>
        <div className={styles.order_list_body_item}>
          <div className={styles.order_list_body_raw}>
            <span className={styles.order_list_body_item_bold}>Roof size in squares</span>
            {!state.isPriceHidden && (
              <span className={styles.order_list_body_item_bold}>
                {`${state.order.roofSize} Squares`}
              </span>
            )}
          </div>
        </div>
        <div className={styles.order_list_body_item}>
          <div className={styles.order_list_body_raw}>
            <span className={styles.order_list_body_item_bold}>Shingle Color</span>
            {!state.isPriceHidden && (
              <span className={styles.order_list_body_item_bold}>{state.order.shingleColor}</span>
            )}
          </div>
        </div>
        <div className={styles.order_list_body_item}>
          <div className={styles.order_list_body_raw}>
            <span className={styles.order_list_body_item_bold}>Warranty</span>
            {!state.isPriceHidden && (
              <span className={styles.order_list_body_item_bold}>
                {state.order.distributionWarranty}
              </span>
            )}
          </div>
        </div>
        {...renderProjectOptions()}
      </OrderDetails>
    </ProposalBlockWrapper>
  );
};
